import { createAction } from '@ngrx/store';

export const enum TypeActionsApp {
	resetString = '[APP COMPONENT] RESET',
}

export const resetDataStore = createAction(TypeActionsApp.resetString);
